export function dataInRequest(params = {}) {
  return {
    type: '@clienteConfig/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@clienteConfig/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@clienteConfig/FAILED_REQUEST',
  };
}

export function updateData(data, params) {
  return {
    type: '@clienteConfig/UPDATE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@clienteConfig/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@clienteConfig/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@clienteConfig/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@clienteConfig/RECORD_FILTERING',
    payload: { params },
  };
}
